import React from 'react';
import { Invoices } from '../../../../api/api-invoices';
import * as types from '../constants/action-types';
import { get } from 'lodash';

export function fetchInvoiceEntriesByBkgRequest (isFetching) {
  return {
    type: types.BKG_INVOICE_ENTRIES_FETCH_REQUEST,
    isFetching
  };
}

export function fetchInvoiceEntriesByBkgSuccess (data) {
  return {
    type: types.BKG_INVOICE_ENTRIES_FETCH_SUCCESS,
    data
  };
}

export function fetchInvoiceEntriesByBkgFailure (fetchError) {
  return {
    type: types.BKG_INVOICE_ENTRIES_FETCH_FAILURE,
    fetchError
  };
}

export function fetchInvoiceEntriesByTypeRequest (isFetching) {
  return {
    type: types.INVOICE_ENTRIES_BY_TYPE_REQUEST,
    isFetching
  }
}

export function fetchInvoiceEntriesByTypeSuccess (data) {
  return {
    type: types.INVOICE_ENTRIES_BY_TYPE_SUCCESS,
    data
  }
}

export function fetchInvoiceEntriesByTypeFailure (fetchError) {
  return {
    type: types.INVOICE_ENTRIES_BY_TYPE_FAILURE,
    fetchError
  }
}

export function fetchInvoiceEntriesByBkg (accessToken, ssoId, bookingId) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchInvoiceEntriesByBkgRequest(true));

      Invoices.fetchBkgInvoiceEntries(accessToken, ssoId, bookingId, response => {
        if (200 === response.statusCode) {
          dispatch(fetchInvoiceEntriesByBkgSuccess(response));

          return resolve(response);
        }
        const defaultErrMsg = `Error fetching invoice entries for booking ${bookingId}`;
        const errorMessage = get(response, 'error', defaultErrMsg);
        dispatch(fetchInvoiceEntriesByBkgFailure(errorMessage));

        return reject(errorMessage);
      });
    });
  };
}

export function fetchInvoiceEntriesByType (accessToken, invoiceId, txnType) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchInvoiceEntriesByTypeRequest(true));

      Invoices.fetchInvoiceEntriesByType(accessToken, invoiceId, txnType, response => {
        if (200 === response.statusCode) {
          dispatch(fetchInvoiceEntriesByTypeSuccess(response));

          return resolve(response);
        }
        const defaultErrMsg = 'Error fetching invoice entries';
        const errorMessage = get(response, 'error', defaultErrMsg);
        dispatch(fetchInvoiceEntriesByTypeFailure(errorMessage));

        return reject(errorMessage);
      });
    });
  };
}
